import { useEffect, useState } from "react";
import parse from "html-react-parser";
import apiRequest from "../../../../../utils/ApiRequest/apiRequest.js";
import Pagination from "../../../../Reusable/Pagination/Pagination.js";
import LoaderContainer from "../../../../Reusable/LoaderContainer/LoaderContainer.js";
import PayoutsHeader from "./PayoutsHeader.js";
import JumboPayTableContainer from "../Utils/JumboPayTable/JumboPayTableContainer.js";
import { BankIds } from "../Utils/Helper.js";
import { useContent } from "../../../../../contexts/contentContext/contentContext.js";
import { convertNumToMoney } from "../Utils/ExternalFunctions.js";

import "../JumboPay.scss";

const Payouts = ({ userData }) => {
  const { getTextByKey, getLanguageCulture, getDirection } = useContent();
  const [allData, setAllData] = useState(null);
  const [userLevel, setUserLevel] = useState(null);
  const [userNextLevel, setUserNextLevel] = useState(null);
  const [userBalanceConverted, setUserBalanceConverted] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const [maxPages, setMaxPages] = useState(1);
  const [loading, setLoading] = useState(false);
  const [isActiveSub, setIsActiveSub] = useState(null);
  const [emptyTransactions, setEmptyTransactions] = useState(false);
  const [feeSettings, setFeeSettings] = useState(null);
  const [amountForNextLevel, setAmountForNextLevel] = useState(null);
  const [percentForNextLevel, setPercentForNextLevel] = useState(null);
  const [bankAccounts, setBankAccounts] = useState(
    userData.User_BankAccounts
      ? Object.values(userData.User_BankAccounts)
      : null
  );
  const defaultBank = bankAccounts
    ? bankAccounts?.find((bank) => bank.defaultBank)
    : null;
  const [bankDisplay, setBankDisplay] = useState(
    defaultBank
      ? getTextByKey(`payment-bank-${BankIds[defaultBank.BankId]}`) +
          "-" +
          defaultBank.BankAccountId
      : null
  );

  const headerTable = [
    {
      enName: "Date",
      constName: "statement-table-date",
      className: "header-request-date",
    },
    {
      enName: "Status",
      constName: "payment-status",
      className: "header-status",
    },
    {
      enName: "Amount",
      constName: "payment-amount",
      className: "header-amount",
    },
    {
      enName: "Fee",
      constName: "fee-text-jumbopay",
      className: "header-fee",
    },
    {
      enName: "Net",
      constName: "net-text-jumbopay",
      className: "header-net",
    },
    {
      enName: "Invoice",
      constName: "statement-table-invoice",
      className: "header-invoice",
    },
  ];
  const getAllActions = async (currentPageNum) => {
    setLoading(true);
    const parameters = {
      culture: getLanguageCulture(),
      top: 10,
      from: currentPageNum * 10 - 10,
    };
    const response = await apiRequest(
      "Transactions",
      "ReactGetAllUserWithdrawals",
      parameters
    );
    if (response.status === "success") {
      if (response.data) {
        setMaxPages(response.data.TransactionsCount);
        setAllData(response.data.JumbopayAllWithdrawals);
        if (response.data.TransactionsCount === 0) {
          setEmptyTransactions(true);
        } else {
          setEmptyTransactions(false);
        }
      }
    }
    setLoading(false);
  };

  const getUserLevel = async () => {
    const response = await apiRequest("JumboFee", "GetUserLevel");
    if (response.status === "success") {
      if (response.data) {
        setUserLevel(response.data);
      }
    }
  };

  const getUserNextLevel = async () => {
    const response = await apiRequest("JumboFee", "GetUserNextLevel");
    if (response.status === "success") {
      if (response.data) {
        setUserNextLevel(response.data);
        GetUserTotalIncomeBalance(response.data);
      }
    }
  };

  const GetUserTotalIncomeBalance = async (nextLevel) => {
    const response = await apiRequest("Users", "GetUserTotalIncomeBalance");
    if (response.status === "success") {
      if (response.data.toString()) {
        let userRevenue = response.data;
        MoneyNumberFormat(
          nextLevel.MinAmount > 0
            ? nextLevel.MinAmount - Number(userRevenue)
            : 1
        );
        setPercentForNextLevel((userRevenue * 100) / nextLevel.MinAmount);
      }
    }
  };

  const MoneyNumberFormat = async (strNumber) => {
    const parameters = {
      NumberAsString: strNumber,
    };
    const response = await apiRequest(
      "JumboFee",
      "MoneyNumberFormat",
      parameters
    );
    if (response.status === "success") {
      if (response.data.toString()) {
        setAmountForNextLevel(response.data);
      }
    }
  };

  const GetUserAvailableBalance = async () => {
    const response = await apiRequest("Users", "GetUserAvailableBalance");
    if (response.status === "success") {
      if (response.data) {
        setUserBalanceConverted(response.data);
      }
    }
  };
  useEffect(() => {
    if (userLevel != null) {
      if (userLevel.Name === "JUMBOPro" || userLevel.Name === "JUMBOBusiness") {
        setIsActiveSub(true);
      } else {
        setIsActiveSub(false);
      }
    }
  }, [userLevel, userNextLevel]);

  //upper the num of pages
  function up(v, n) {
    return Math.ceil(v * Math.pow(10, n)) / Math.pow(10, n);
  }

  const fixRequestDate = (requestDate) => {
    let temp = requestDate;
    if (requestDate.includes("#Payment_transaction_id#")) {
      temp = requestDate.replace(
        "#Payment_transaction_id#",
        getTextByKey("payment-transaction-id")
      );
    }
    return temp;
  };
  const fixStatusDisplay = (status) => {
    let temp = status;
    if (status.includes("#Payment_status_complete#")) {
      temp = status.replace(
        "#Payment_status_complete#",
        getTextByKey("payment-status-complete")
      );
    } else if (status.includes("#Payment_status_canceled#")) {
      temp = status.replace(
        "#Payment_status_canceled#",
        getTextByKey("payment-status-canceled")
      );
    } else if (status.includes("#Payment_status_pending#")) {
      temp = status.replace(
        "#Payment_status_pending#",
        getTextByKey("payment-status-pending")
      );
    } else if (status.includes("#Payment_withdrawal_request_status#")) {
      temp = status.replace(
        "#Payment_withdrawal_request_status#",
        getTextByKey("payment-request-withdrawal")
      );
    }

    return temp;
  };

  const fetchJumboFeeSettings = async () => {
    const response = await apiRequest(
      "Transactions",
      "GetJumbopayFeesSettings"
    );
    if (response.status === "success") {
      setFeeSettings(response.data);
    }
  };

  useEffect(() => {
    fetchJumboFeeSettings();
    GetUserByBearer();
    getUserLevel();
    getUserNextLevel();
    GetUserAvailableBalance();
  }, []);

  useEffect(() => {
    getAllActions(currentPage);
  }, [currentPage]);

  const GetUserByBearer = async () => {
    const response = await apiRequest("Users", "GetUserByBearer");
    if (response.status === "success") {
      if (response.data) {
        setBankAccounts(Object.values(response?.data.User_BankAccounts || {}));
      }
    }
  };

  useEffect(() => {
    if (bankAccounts) {
      if (bankAccounts[1]) {
        if (bankAccounts[1].defaultBank) {
          const displayTemp =
            getTextByKey(`payment-bank-${BankIds[bankAccounts[1].BankId]}`) +
            "-" +
            bankAccounts[1].BankAccountId;
          setBankDisplay(displayTemp);
        } else {
          setBankDisplay(getTextByKey("Payment_no_bank_set"));
        }
      }
    }
  }, [bankAccounts]);

  const fixInvoiceMail = (invoice) => {
    let temp = invoice;

    if (invoice && invoice.includes("#Payment_Payouts_Invoice_Alt#")) {
      temp = invoice.replace(
        "#Payment_Payouts_Invoice_Alt#",
        getTextByKey("jumbopay-invoice-tooltip")
      );
    }
    return temp;
  };

  const bodyTable = [
    {
      fieldClass: `item-request-date ${
        getDirection() === "rtl" ? "request-date-rtl" : ""
      }`,
      fieldName: "RequestDateConverted",
      render: (item) =>
        item.Withdrawal_Created_date_converted &&
        parse(fixRequestDate(item.Withdrawal_Created_date_converted)),
    },
    {
      fieldClass: `item-status`,
      fieldName: "Status",
      render: (item) => (
        <>
          {parse(item.Withdrawal_Status_Icon)}{" "}
          {parse(fixStatusDisplay(item.Withdrawal_Status))}
        </>
      ),
    },
    {
      fieldClass: `item-amount`,
      fieldName: "AmountWithCurrency",
      render: (item) =>
        convertNumToMoney({
          num: item.Withdrawal_Amount,
        }),
    },
    {
      fieldClass: `item-fee`,
      fieldName: "FeeWithCurrency",
      render: (item) =>
        convertNumToMoney({
          num: item.Withdrawal_Fee,
        }),
    },
    {
      fieldClass: `item-net`,
      fieldName: "NetWithCurrency",
      render: (item) =>
        convertNumToMoney({
          num: item.Withdrawal_Total,
        }),
    },
    {
      fieldClass: `item-invoice`,
      fieldName: "InvoiceUrl",
      render: (item) =>
        item.transaction_invoiceUrl &&
        parse(fixInvoiceMail(item.transaction_invoiceUrl)),
    },
  ];
  const mobileRenderRow = (item, i) => {
    return (
      <div key={i} className="row-item-table">
        <div className="item-request-date">
          {item.Withdrawal_Created_date_converted &&
            parse(fixRequestDate(item.Withdrawal_Created_date_converted))}
          <span className="status">
            {item.Withdrawal_Status_Icon && parse(item.Withdrawal_Status_Icon)}{" "}
            {item.Withdrawal_Status &&
              parse(fixStatusDisplay(item.Withdrawal_Status))}
          </span>
        </div>
        <div className="item-amount mobile-style">
          <span className="type">{getTextByKey("payment-amount")}</span>
          {convertNumToMoney({
            num: item.Withdrawal_Amount,
          })}
        </div>
        <div className="item-fee mobile-style">
          <span className="type">{getTextByKey("fee-text-jumbopay")}</span>
          {convertNumToMoney({
            num: item.Withdrawal_Fee,
          })}
        </div>
        <div className="item-net mobile-style">
          <span className="type">{getTextByKey("net-text-jumbopay")}</span>
          {convertNumToMoney({
            num: item.Withdrawal_Total,
          })}
        </div>
        <div className="item-invoice mobile-style">
          <span className="type">
            {getTextByKey("statement-table-invoice")}
          </span>
          {item.transaction_invoiceUrl &&
            parse(fixInvoiceMail(item.transaction_invoiceUrl))}
        </div>
      </div>
    );
  };

  return (
    <div className="account-status-container">
      <PayoutsHeader
        userBalanceConverted={userBalanceConverted}
        isActiveSub={isActiveSub}
        bankAccounts={bankAccounts}
        bankDisplay={bankDisplay}
        feeSettings={feeSettings}
        userData={userData}
      />
      <div className="data-table">
        <h3>{getTextByKey("payment-payouts-withdrawal-history")}</h3>
        <JumboPayTableContainer
          data={allData}
          tableSecture={bodyTable}
          headerTable={headerTable}
          mobileRowRender={mobileRenderRow}
          emptyTransactions={emptyTransactions}
          loading={loading}
          emptyTransactionsText="payment-no-money"
        />
        {!emptyTransactions && !loading && maxPages > 10 && (
          <Pagination
            currentPage={currentPage}
            maxPages={maxPages > 0 ? up(maxPages / 10, 0) : 1}
            setCurrentPage={setCurrentPage}
          />
        )}
      </div>
      <LoaderContainer isLoading={loading} />
    </div>
  );
};

export default Payouts;
